var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPause21 = function SvgIconPause21(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B328C",
    d: "M1.972 38.024h7.7V1.977h-7.7v36.047zM0 40h11.643V0H0v40zm20.328-1.976h7.7V1.977h-7.7v36.047zM18.357 40H30V0H18.357v40z"
  })));
};
export default SvgIconPause21;